module.exports = __webpack_public_path__ + "static/media/selection.0878231c.svg";